import { Button } from '@cian/ui-kit';
import * as React from 'react';
import { useDispatch, useSelector } from 'react-redux';

import { IUpdateNoteParams, updateNote } from '../../actions/favoriteEntities/notes';
import { Comment, CommentForm } from '../../components/MapOfferCard';
import { selectOfferByRealtyOfferIdForMap, selectOfferNoteStatus } from '../../selectors';
import { EOfferNoteStatus } from '../../types/offersByRealtyOfferId';

export const MapOfferCardCommentContainer = () => {
  const dispatch = useDispatch();
  const [isEditComment, setIsEditComment] = React.useState(false);

  const selectedOffer = useSelector(selectOfferByRealtyOfferIdForMap);
  const offerNoteStatus = useSelector(selectOfferNoteStatus);

  const { note, entityId } = selectedOffer;

  const handleEditComment = () => {
    setIsEditComment(true);
  };

  const handleCancelComment = () => {
    setIsEditComment(false);
  };

  const handleSubmitComment = (params: IUpdateNoteParams) => {
    dispatch(updateNote({ entityId: params.entityId, comment: params.comment, successCallback: handleCancelComment }));
  };

  React.useEffect(() => {
    handleCancelComment();
  }, [entityId]);

  return (
    <>
      {!note && !isEditComment && (
        <div data-testid="add_note_button">
          <Button size="XS" theme="stroke_secondary" onClick={handleEditComment}>
            Добавить заметку
          </Button>
        </div>
      )}
      {note && !isEditComment && <Comment comment={note} onEditComment={handleEditComment} />}
      {isEditComment && (
        <CommentForm
          comment={note}
          entityId={entityId}
          onSubmitComment={handleSubmitComment}
          onCancelComment={handleCancelComment}
          isFetching={offerNoteStatus === EOfferNoteStatus.Loading}
        />
      )}
    </>
  );
};
